<script setup lang="ts">
import { routes } from '@/router';
</script>

<template>
  <footer class="bg-foreground text-background py-12 md:py-16">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
        <div class="space-y-4">
          <h3 class="text-secondary font-heading text-2xl font-semibold">MAYA</h3>
          <p class="text-background/70 text-pretty text-sm leading-relaxed">
            Une force de transformation pour révéler votre essence unique
          </p>
        </div>

        <div class="space-y-4">
          <h4 class="font-heading text-lg font-medium">Navigation</h4>
          <nav class="flex flex-col gap-2">
            <ul>
              <li>
                <RouterLink :to="routes.home.path" class="text-background/70 hover:text-secondary w-fit text-sm">
                  Accueil
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{ path: '/', hash: '#yoga' }"
                  class="text-background/70 hover:text-secondary w-fit text-sm"
                >
                  Yoga
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{ path: '/', hash: '#ayurveda' }"
                  class="text-background/70 hover:text-secondary w-fit text-sm"
                >
                  Ayurvéda
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="routes.coaching.path" class="text-background/70 hover:text-secondary w-fit text-sm">
                  Coaching
                </RouterLink>
              </li>
            </ul>
          </nav>
        </div>

        <div class="space-y-4">
          <h4 class="font-heading text-lg font-medium">Contact</h4>
          <div class="flex flex-col gap-3">
            <a href="tel:+33682293900" class="text-background/70 hover:text-secondary flex items-center gap-3 text-sm">
              <Icon icon-name="phone" class="h-4 w-4" />
              <span>+33 6 82 29 39 00</span>
            </a>
            <a
              href="mailto:contact@maya-yoga.fr"
              class="text-background/70 hover:text-secondary flex items-center gap-3 text-sm"
            >
              <Icon icon-name="email" class="h-4 w-4" />
              <span>contact@maya-yoga.fr</span>
            </a>
            <div class="text-background/70 flex items-start gap-3 text-sm">
              <Icon icon-name="mapPin" class="h-4 w-4" />
              <span>Metz, France</span>
            </div>
          </div>
        </div>
      </div>

      <div class="border-background/10 mt-12 border-t pt-8 text-center">
        <p class="text-background/50 text-sm">
          MAYA B. Rosemarie - {{ new Date().getFullYear() }} - Tous droits réservés
        </p>
      </div>
    </div>
  </footer>
</template>
